import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { validaSoloNumero, validaEmail } from "../../util/varios";
import moment from "moment";
import axios from "axios";
import { Loader, Dimmer } from "semantic-ui-react";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoOrganizacion from "../../catalogosAthos/catalogoOrganizacion";
import { CambiarClaveApp } from "./modalCambiarClaveApp";

const ModalActualizarUsuarioApp = (props) => {
  let idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
  let op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let idusuario = JSON.parse(sessionStorage.getItem("idusuario"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnEnviar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [body, setBody] = useState({});
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [password, setPassword] = useState("");
  const [activate, setActivate] = useState(false);
  const [usuario, setUsuario] = useState();
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const cmbCedula = [
    { value: "V" },
    { value: "E" },
    { value: "J" },
    { value: "P" },
    { value: "G" },
  ];
  const [persona, setPersona] = useState({
    cedula: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    fnacimiento: "",
    nacionalidad: "",
    sexo: "",
  });
  const [modulosincroniza, setModulosincroniza] = useState({
    sincro1: null,
    sincro2: null,
  });
  const [modulopedidos, setModulopedidos] = useState({
    pedidos1: null,
    pedidos2: null,
    pedidos3: null,
    pedidos4: null,
    pedidos5: null,
  });
  const [modulonataentrega, setModulonataentrega] = useState({
    entrega1: null,
    entrega2: null
  });
  const [moduloanticipo, setModuloanticipo] = useState({
    antic1: null,
    antic2: null,
    antic3: null,
  });
  const [moduloclientes, setModuloclientes] = useState({
    clients1: null,
    clients2: null,
    clients3: null
  });
  const [moduloconfigura, setModuloconfigura] = useState({
    config1: null,
    config2: null,
    config3: null
  });
  const [modulofcompras, setModulofcompras] = useState({
    compras1: null,
    compras2: null,
  });
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex1, setTabIndex1] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    sessionStorage.getItem("fechasistema")
  );
  const [modu1, setModu1] = useState(0);
  const [modu2, setModu2] = useState(0);
  const [modu3, setModu3] = useState(0);
  const [modu4, setModu4] = useState(0);
  const [modu5, setModu5] = useState(0);
  const [modu6, setModu6] = useState(0);
  const [modu7, setModu7] = useState(0);
  const [tipov, setTipov] = useState(0);

  const cmbRif = useRef();
  const txtRif = useRef();
  const txtRazon = useRef();
  const txtIdVendedor = useRef();
  const cmbCaja = useRef();
  const cmbStatus = useRef();

  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  const txtIdAgente = useRef();
  const txtNombreAgente = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const txtSincronizarsi = useRef();
  const txtSincronizarno = useRef();
  const txtPedidossi = useRef();
  const txtPedidosno = useRef();
  const txtNotasentregasi = useRef();
  const txtNotasentregano = useRef();
  const txtAnticipossi = useRef();
  const txtAnticiposno = useRef();
  const txtConfiguracionsi = useRef();
  const txtConfiguracionno = useRef();
  const txtTodosSincronizar = useRef();
  const txtTodosPedidos = useRef();
  const txtTodosnotasentrega = useRef();
  const txtTodosanticipos = useRef();
  const txtTodosConfiguracion = useRef();
  const txtRecibirProductos = useRef();
  const txtEnviarPedidos = useRef();
  const txtCrearPedidos = useRef();
  const txtListaPedidos = useRef();
  const txtListaPedidosClientes = useRef();
  const txtEditarPedido = useRef();
  const txtPedidoGnotaentrega = useRef();
  const txtListaNotasEntregas = useRef();
  const txtCrearAnticipos = useRef();
  const txtListaAnticipos = useRef();
  const txtImprimirAnticipos = useRef();
  const txtEliminarRegistros = useRef();
  const txtListaMonedas = useRef();
  const txtFactucompras = useRef();
  const txtListaFactucompras = useRef();
  const txtClientessi = useRef();
  const txtClientesno = useRef();
  const txtTodosClientes = useRef();
  const txtListaClientes = useRef();
  const txtDeudas = useRef();
  const txtComprassi = useRef();
  const txtComprasno = useRef();
  const txtTodosCompras = useRef();
  const txtVaciosapp = useRef();
  const txtVaciosClient = useRef();
  const txtPrestamoVacios = useRef();
  const txtObsequio = useRef();
  const txtCierreVacios = useRef();
  const txtCierreVaciosPlus = useRef();
  const txtTipoventasi = useRef();
  const txtTipoventano = useRef();
  const txtUbiCLientes = useRef();


  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/athos/usuarioapp/actualizar/${operacion}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);

          var mensaje = "";
          if (operacion === 1) {
            mensaje =
              "El Usuario " +
              response.data.iduser +
              " ha sido Registrada Correctamente.";
          } else if (operacion === 2) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido Modificado Correctamente.";
          } else if (operacion === 3) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido Eliminado Correctamente.";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: mensaje,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/athos/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }

          setHabilitadoNU(true);

          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              setTabIndex(1);
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (values) => {
    setMostrar3(false);
    txtCedula.current.value = values.cedPer;
    txtNombreUsuario.current.value = values.nomPer;
    txtApellidoUsuario.current.value = values.apePer;
    txtDireccionUsuario.current.value = values.direPer;
    txtEmailUsuario.current.value = values.correoPer;
    txtTlfUsuario.current.value = values.tlf1Per;
    txtCelUsuario.current.value = values.tlf2Per;
    txtFechaNac.current.value = moment(values.fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = values.nacPer;
    cmbSexo.current.value = values.sexoPer;
    btnAcepta.current.focus();
  };

  const handleAceptaCatalogoOrg = (values) => {
    setMostrar(false);
    txtIdAgente.current.value = values.idorganizacion;
    txtNombreAgente.current.value = values.nombre;
    txtCedula.current.focus();
  };

  const blanquear = () => {
    setPassword("");
    setActivate(false);
    setOperacionPer(0);
    setModu1(0);
    setModu2(0);
    setModu3(0);
    setModu4(0);
    setModu5(0);
    setModu6(0);
    setTipov(0);
    setModulosincroniza("");
    setModulopedidos("");
    setModulonataentrega("");
    setModuloanticipo("");
    setModuloclientes("");
    setModuloconfigura("");
    setModulofcompras("");
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtConfirmPassword.current.focus();
        } else {
          txtIdAgente.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const validarAgente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setContar(0);
        setTecla(event.which);
        datosAgente(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";

    let endpoint = `${op.conexion}/api/athos/consulta/modeli?campos=${campos}&id=${idagente}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtNombreAgente.current.value = response.data.nombre;
            txtCedula.current.focus();
            setContar(contar + 1);
          } else {
            txtNombreAgente.current.value = "";
            txtIdAgente.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "la organizacion no existe.",
              icono: "informacion",
            });
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    var mensaje = "";

    if (txtLogin.current.value.trim() === "") {
      mensaje = "El Usuario no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      mensaje = "La Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      mensaje = "La Confirmación de la Contraseña no debe estar vacia";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
      txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      mensaje = "Las Contraseñas no coinciden";
      sigue = false;
      setTabIndex(0);
      txtConfirmPassword.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      mensaje = "La cedula no debe estar vacia";
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      mensaje = "Los nombres no deben estar vacios";
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      mensaje = "Los Apellidos no deben estar vacio";
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      mensaje = "La direccion del Usuario no debe estar vacia";
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      mensaje = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
      txtFechaNac.current.focus();
    }

    if (sigue) {
      var user = [];
      var datoPer = [];
      let parameter1 = "";
      let parameter2 = "";
      let parameter3 = "";
      let parameter4 = "";
      let parameter5 = "";
      let parameter6 = "";
      let parameter7 = "";
      let parameter8 = "";
      let parameter9 = "";
      let parameter10 = "";

      if (modu1 === 1 || modu2 === 1 || modu3 === 1 || modu4 === 1 || modu5 === 1 || modu6 === 1 || modu7) {

        let val1 = txtSincronizarsi.current.checked === true ? "1" : "0";
        let val2 = txtPedidossi.current.checked === true ? "1" : "0";
        let val3 = txtNotasentregasi.current.checked === true ? "1" : "0";
        let val4 = txtAnticipossi.current.checked === true ? "1" : "0";
        let val5 = txtConfiguracionsi.current.checked === true ? "1" : "0";
        let val6 = txtClientessi.current.checked === true ? "1" : "0";
        let val7 = txtComprassi.current.checked === true ? "1" : "0";


        parameter1 = val1 + val2 + val3 + val4 + val5 + val6 + val7;
      } else {

        parameter1 = '0000000';

      }

      if (modu1 === 1) {

        let val1 = txtRecibirProductos.current.checked === true ? "1" : "0";
        let val2 = txtEnviarPedidos.current.checked === true ? "1" : "0";

        parameter2 = val1 + val2;
      } else {

        parameter2 = '0000';

      }

      if (modu2 === 1) {

        let val1 = txtCrearPedidos.current.checked === true ? "1" : "0";
        let val2 = txtListaPedidos.current.checked === true ? "1" : "0";
        let val3 = txtListaPedidosClientes.current.checked === true ? "1" : "0";
        let val4 = txtPedidoGnotaentrega.current.checked === true ? "1" : "0";
        let val5 = txtEditarPedido.current.checked === true ? "1" : "0";

        parameter3 = val1 + val2 + val3 + val4 + val5;
      } else {

        parameter3 = '00000';

      }

      if (modu3 === 1) {

        let val1 = txtListaNotasEntregas.current.checked === true ? "1" : "0";
        let val2 = txtObsequio.current.checked === true ? "1" : "0";

        parameter10 = val2;
        parameter4 = val1;
      } else {

        parameter10 = '0';
        parameter4 = '0000';

      }

      if (modu4 === 1) {

        let val1 = txtCrearAnticipos.current.checked === true ? "1" : "0";
        let val2 = txtListaAnticipos.current.checked === true ? "1" : "0";
        let val3 = txtImprimirAnticipos.current.checked === true ? "1" : "0";

        parameter5 = val1 + val2 + val3;
      } else {

        parameter5 = '0000';

      }

      if (modu5 === 1) {

        let val1 = txtEliminarRegistros.current.checked === true ? "1" : "0";
        let val2 = txtListaMonedas.current.checked === true ? "1" : "0";
        let val3 = "0";

        parameter6 = val1 + val2 + val3;
      } else {

        parameter6 = '0000';

      }

      if (modu6 === 1) {

        let val1 = txtListaClientes.current.checked === true ? "1" : "0";
        let val2 = txtDeudas.current.checked === true ? "1" : "0";
        let val3 = txtUbiCLientes.current.checked === true ? "1" : "0";

        parameter7 = val1 + val2 + val3;
      } else {

        parameter7 = '0000';

      }

      if (modu7 === 1) {

        let val1 = txtFactucompras.current.checked === true ? "1" : "0";
        let val2 = txtListaFactucompras.current.checked === true ? "1" : "0";

        parameter8 = val1 + val2;
      } else {
        parameter8 = '00000';
      }

      if (tabIndex1 === 1) {
        let val1 = txtVaciosapp.current.checked === true ? "1" : "0";
        let val2 = txtVaciosClient.current.checked === true ? "1" : "0";
        let val3 = txtCierreVacios.current.checked === true ? "1" : "0";
        let val4 = txtCierreVaciosPlus.current.checked === true ? "1" : "0";
        let val5 = txtPrestamoVacios.current.checked === true ? "1" : "0";

        parameter9 = val1 + val2 + val3 + val4 + val5;
      } else {
        parameter9 = '00000';
      }

      user.push({
        idusuario:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        login: txtLogin.current.value,
        passwd: txtPassword.current.value,
        persona: txtCedula.current.value,
        status: cmbStatus.current.value,
        ...(props.menu !== "sistema" && {
          idagente: txtIdVendedor.current.value,
        }),
        ...(props.menu !== "sistema" && { numcaja: cmbCaja.current.value }),
        idorganizacion:
          props.menu === "sistema" ? txtIdAgente.current.value : idorganizacion,
        accaplicaciones: parameter1,
        accpedidos: parameter3,
        accnotaentregas: parameter4,
        accconfig: parameter6,
        accanticipos: parameter5,
        accsincronizar: parameter2,
        accclientes: parameter7,
        acccompras: parameter8,
        accvacios: parameter9,
        obsequio: parameter10,
        tipotransaccion: tipov
      });

      datoPer.push({
        apellidos: txtApellidoUsuario.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailUsuario.current.value,
        direccion: txtDireccionUsuario.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfUsuario.current.value,
        tlf2: txtCelUsuario.current.value,
      });

      setUsuario(user);
      setPersona(datoPer);
      setContar2(0);
      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify(user),
        perso: JSON.stringify(datoPer),
      };
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
      setBody(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: mensaje,
        icono: "informacion",
      });
    }
  };

  const seleccionarVendedor = (rif, desde) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = desde === 1 ? "idagente" : "rif";
    let nomid2 = "vendedor";
    let id = rif;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data !== "") {
          txtIdVendedor.current.value = response.data.idagente;
          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
          txtRif.current.value = response.data.rif.trim().substring(1, 10);
          txtRazon.current.value = response.data.nombre.trim();
        }
        if (desde === 1) {
          vaciosApp();
        } else {
          setActivate(false);
        }
      })
      .catch(function (error) {
        console.error(error);
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);
    txtRazon.current.value = "";
    txtIdVendedor.current.value = "";
    seleccionarVendedor(values.rif.trim(), 2);
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        txtRazon.current.value = "";
        txtIdVendedor.current.value = "";
        seleccionarVendedor(rif, 2);
      }
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.render();
    props.onHideAcepta();
    blanquear();
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);

  const handleChangeOtro = (event) => {

    if (event.target.name === "tipoventa") {
      if (txtTipoventasi.current.checked === true) {
        setTipov(0);
        setModu3(1);
        setModulonataentrega({
          entrega1: "0",
          entrega2: "0"
        });
        txtNotasentregasi.current.checked = true;
        txtNotasentregano.current.checked = false;
      } else if (txtTipoventano.current.checked === true) {
        setTipov(1);
        setModu3(0);
        setModulonataentrega({
          entrega1: "0",
          entrega2: "0"
        });
        txtNotasentregasi.current.checked = false;
        txtNotasentregano.current.checked = true;
      }
    } else if (event.target.name === "permisincroniza") {
      if (txtSincronizarsi.current.checked === true) {
        setModu1(1);
      } else if (txtSincronizarno.current.checked === true) {
        setModu1(0);
        setModulosincroniza({
          sincro1: "0",
          sincro2: "0",
        });
      }
    } else if (event.target.name === "permipedidos") {
      if (txtPedidossi.current.checked === true) {
        setModu2(1);
        setModulopedidos({
          pedidos1: "0",
          pedidos2: "0",
          pedidos3: "0",
          pedidos4: "0",
          pedidos5: "0"
        });
      } else if (txtPedidosno.current.checked === true) {
        setModu2(0);
      }
    } else if (event.target.name === 'perminotaentrega') {
      if (txtNotasentregasi.current.checked === true) {
        setModu3(1);
        setModulonataentrega({
          entrega1: "0",
          entrega2: "0"
        });
      } else if (txtNotasentregano.current.checked === true) {
        setModu3(0);
      }
    } else if (event.target.name === 'permianticipos') {
      if (txtAnticipossi.current.checked === true) {
        setModu4(1);
        setModuloanticipo({
          antic1: "0",
          antic2: "0",
          antic3: "0",
        });
      } else if (txtAnticiposno.current.checked === true) {
        setModu4(0);
      }
    } else if (event.target.name === 'permiconfiguracion') {
      if (txtConfiguracionsi.current.checked === true) {
        setModu5(1);
        setModuloconfigura({
          config1: "0",
          config2: "0",
          config3: "0"
        });
      } else if (txtConfiguracionno.current.checked === true) {
        setModu5(0);
      }
    } else if (event.target.name === 'permiclientes') {
      if (txtClientessi.current.checked === true) {
        setModu6(1);
        setModuloclientes({
          clients1: "0",
          clients2: "0"
        });
      } else if (txtClientesno.current.checked === true) {
        setModu6(0);
      }
    } else if (event.target.name === 'factucompras') {
      if (txtComprassi.current.checked === true) {
        setModu7(1);
        setModulofcompras({
          compras1: "0",
          compras2: "0"
        });
      } else if (txtComprasno.current.checked === true) {
        setModu7(0);
      }
    }
  };

  const checkBlank = (e) => {

    if (e.target.name === 'sincroniza' && modu1 === 1) {

      if (txtRecibirProductos.current.checked && txtEnviarPedidos.current.checked) {
        txtTodosSincronizar.current.checked = true;
      } else {
        txtTodosSincronizar.current.checked = false;
      }

    } else if (e.target.name === 'pedidos' && modu2 === 1) {

      if (txtCrearPedidos.current.checked && txtListaPedidos.current.checked &&
        txtListaPedidosClientes.current.checked && txtPedidoGnotaentrega.current.checked && txtEditarPedido.current.checked
      ) {
        txtTodosPedidos.current.checked = true;
      } else {
        txtTodosPedidos.current.checked = false;
      }

    } else if (e.target.name === 'notasentrega' && modu3 === 1) {

      if (txtListaNotasEntregas.current.checked && txtObsequio.current.checked) {
        txtTodosnotasentrega.current.checked = true;
      } else {
        txtTodosnotasentrega.current.checked = false;
      }

    } else if (e.target.name === 'anticipos' && modu4 === 1) {

      if (txtCrearAnticipos.current.checked && txtListaAnticipos.current.checked &&
        txtImprimirAnticipos.current.checked) {
        txtTodosanticipos.current.checked = true;
      } else {
        txtTodosanticipos.current.checked = false;
      }

    } else if (e.target.name === 'configura' && modu5 === 1) {

      if (txtEliminarRegistros.current.checked && txtListaMonedas.current.checked) {
        txtTodosConfiguracion.current.checked = true;
      } else {
        txtTodosConfiguracion.current.checked = false;
      }

    } else if (e.target.name === 'clientes' && modu6 === 1) {

      if (txtListaClientes.current.checked && txtDeudas.current.checked && txtUbiCLientes.current.checked) {
        txtTodosClientes.current.checked = true;
      } else {
        txtTodosClientes.current.checked = false;
      }

    } else if (e.target.name === 'factucompra' && modu7 === 1) {
      if (txtFactucompras.current.checked && txtListaFactucompras.current.checked) {
        txtTodosCompras.current.checked = true;
      } else {
        txtTodosCompras.current.checked = false;
      }
    }

  };

  const checkTodo = (event) => {
    if (event.target.name === "todossincroniza") {
      if (txtTodosSincronizar.current.checked) {
        txtRecibirProductos.current.checked = true;
        txtEnviarPedidos.current.checked = true;
      } else {
        txtRecibirProductos.current.checked = false;
        txtEnviarPedidos.current.checked = false;
      }
    } else if (event.target.name === "todospedidos") {
      if (txtTodosPedidos.current.checked) {
        txtCrearPedidos.current.checked = true;
        txtListaPedidos.current.checked = true;
        txtListaPedidosClientes.current.checked = true;
        txtPedidoGnotaentrega.current.checked = true;
        txtEditarPedido.current.checked = true;
      } else {
        txtCrearPedidos.current.checked = false;
        txtListaPedidos.current.checked = false;
        txtListaPedidosClientes.current.checked = false;
        txtPedidoGnotaentrega.current.checked = false;
        txtEditarPedido.current.checked = false;
      }
    } else if (event.target.name === "todosnotaentregas") {
      if (txtTodosnotasentrega.current.checked) {
        txtListaNotasEntregas.current.checked = true;
        txtObsequio.current.checked = true;
      } else {
        txtListaNotasEntregas.current.checked = false;
        txtObsequio.current.checked = false;
      }
    } else if (event.target.name === "todosanticipos") {
      if (txtTodosanticipos.current.checked) {
        txtCrearAnticipos.current.checked = true;
        txtListaAnticipos.current.checked = true;
        txtImprimirAnticipos.current.checked = true;
      } else {
        txtCrearAnticipos.current.checked = false;
        txtListaAnticipos.current.checked = false;
        txtImprimirAnticipos.current.checked = false;
      }
    } else if (event.target.name === "todosconfigura") {
      if (txtTodosConfiguracion.current.checked) {
        txtEliminarRegistros.current.checked = true;
        txtListaMonedas.current.checked = true;
      } else {
        txtEliminarRegistros.current.checked = false;
        txtListaMonedas.current.checked = false;
      }
    } else if (event.target.name === 'todosclientes') {
      if (txtTodosClientes.current.checked) {
        txtListaClientes.current.checked = true;
        txtDeudas.current.checked = true;
        txtUbiCLientes.current.checked = true;
      } else {
        txtListaClientes.current.checked = false;
        txtDeudas.current.checked = false;
        txtUbiCLientes.current.checked = false;
      }
    } else if (event.target.name === 'todoscompras') {
      if (txtTodosCompras.current.checked) {
        txtFactucompras.current.checked = true;
        txtListaFactucompras.current.checked = true;
      } else {
        txtFactucompras.current.checked = false;
        txtListaFactucompras.current.checked = false;
      }
    }
  };

  const vaciosApp = () => {

    let endpoint = `${op.conexion}/api/consulta/vacios`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.vacios !== "NO") {
            setTabIndex1(1);
            if (props.usuario.accvacios.toString().substring(0, 1) === "1") {
              txtVaciosapp.current.checked = true;
              if (props.usuario.accvacios.toString().substring(1, 2) === "1") {
                txtVaciosClient.current.checked = true;
              } else {
                txtVaciosClient.current.checked = false;
              }

              if (props.usuario.accvacios.toString().substring(2, 3) === "1") {
                txtCierreVacios.current.checked = true;
              } else {
                txtCierreVacios.current.checked = false;
              }

              if (props.usuario.accvacios.toString().substring(3, 4) === "1") {
                txtCierreVaciosPlus.current.checked = true;
              } else {
                txtCierreVaciosPlus.current.checked = false;
              }

              if (props.usuario.accvacios.toString().substring(4, 5) === "1") {
                txtPrestamoVacios.current.checked = true;
              } else {
                txtPrestamoVacios.current.checked = false;
              }
            } else {
              txtVaciosapp.current.checked = false;
              txtVaciosClient.current.checked = false;
              txtCierreVacios.current.checked = false;
              txtCierreVaciosPlus.current.checked = false;
              txtPrestamoVacios.current.checked = false;
            }
          } else {
            setTabIndex1(0);
            txtVaciosapp.current.checked = false;
            txtVaciosClient.current.checked = false;
            txtCierreVacios.current.checked = false;
            txtCierreVaciosPlus.current.checked = false;
            txtPrestamoVacios.current.checked = false;
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setDeshabilitado(props.deshabilitado);
        setTabIndex(0);
        if (props.operacion !== 1) {

          if (
            props.usuario.idagente !== null &&
            props.usuario.idagente !== ""
          ) {
            seleccionarVendedor(props.usuario.idagente, 1);
          }

          if (props.usuario.accaplicaciones !== "00000000") {

            if (props.usuario.tipotransaccion === '1') {
              txtTipoventasi.current.checked = false;
              txtTipoventano.current.checked = true;
              setTipov(1);
            } else {
              txtTipoventasi.current.checked = true;
              txtTipoventano.current.checked = false;
              setTipov(0);
            }

            if (props.usuario.accaplicaciones.toString().substring(0, 1) === "1") {

              if (props.usuario && props.usuario.accsincronizar !== "") {
                setModulosincroniza({
                  sincro1: props.usuario.accsincronizar.toString().substring(0, 1),
                  sincro2: props.usuario.accsincronizar.toString().substring(1, 2),
                });
              }

              txtSincronizarsi.current.checked = true;
              txtSincronizarno.current.checked = false;
              setModu1(1);
            } else {
              txtSincronizarsi.current.checked = false;
              txtSincronizarno.current.checked = true;
              setModu1(0);
            }

            if (props.usuario.accaplicaciones.toString().substring(1, 2) === "1") {

              if (props.usuario && props.usuario.accpedidos !== "") {
                setModulopedidos({
                  pedidos1: props.usuario.accpedidos.toString().substring(0, 1),
                  pedidos2: props.usuario.accpedidos.toString().substring(1, 2),
                  pedidos3: props.usuario.accpedidos.toString().substring(2, 3),
                  pedidos4: props.usuario.accpedidos.toString().substring(4, 5),
                  pedidos5: props.usuario.accpedidos.toString().substring(3, 4)
                });
              } else {
              }

              txtPedidossi.current.checked = true;
              txtPedidosno.current.checked = false;
              setModu2(1);
            } else {
              txtPedidossi.current.checked = false;
              txtPedidosno.current.checked = true;
              setModu2(0);
            }

            if (props.usuario.accaplicaciones.toString().substring(2, 3) === "1") {

              if (props.usuario && props.usuario.accnotaentregas !== "") {
                setModulonataentrega({
                  entrega1: props.usuario.accnotaentregas.toString().substring(0, 1),
                  entrega2: props.usuario.obsequio.toString().substring(0, 1)
                });
              } else {
              }

              txtNotasentregasi.current.checked = true;
              txtNotasentregano.current.checked = false;
              setModu3(1);
            } else {
              txtNotasentregasi.current.checked = false;
              txtNotasentregano.current.checked = true;
              setModu3(0);
            }

            if (props.usuario.accaplicaciones.toString().substring(3, 4) === "1") {

              if (props.usuario && props.usuario.accanticipos !== "") {
                setModuloanticipo({
                  antic1: props.usuario.accanticipos.toString().substring(0, 1),
                  antic2: props.usuario.accanticipos.toString().substring(1, 2),
                  antic3: props.usuario.accanticipos.toString().substring(2, 3),
                });
              } else {
              }

              txtAnticipossi.current.checked = true;
              txtAnticiposno.current.checked = false;
              setModu4(1);
            } else {
              txtAnticipossi.current.checked = false;
              txtAnticiposno.current.checked = true;
              setModu4(0);
            }

            if (props.usuario.accaplicaciones.toString().substring(4, 5) === "1") {

              if (props.usuario && props.usuario.accconfig !== "") {
                setModuloconfigura({
                  config1: props.usuario.accconfig.toString().substring(0, 1),
                  config2: props.usuario.accconfig.toString().substring(1, 2)
                });
              } else {
              }

              txtConfiguracionsi.current.checked = true;
              txtConfiguracionno.current.checked = false;
              setModu5(1);
            } else {
              txtConfiguracionsi.current.checked = false;
              txtConfiguracionno.current.checked = true;
              setModu5(0);
            }

            if (props.usuario.accaplicaciones.toString().substring(5, 6) === "1") {

              if (props.usuario && props.usuario.accclientes !== "") {
                setModuloclientes({
                  clients1: props.usuario.accclientes.toString().substring(0, 1),
                  clients2: props.usuario.accclientes.toString().substring(1, 2),
                  clients3: props.usuario.accclientes.toString().substring(2, 3)
                });
              } else {
              }

              txtClientessi.current.checked = true;
              txtClientesno.current.checked = false;
              setModu6(1);
            } else {
              txtClientessi.current.checked = false;
              txtClientesno.current.checked = true;
              setModu6(0);
            }

            if (props.usuario.accaplicaciones.toString().substring(6, 7) === "1") {
              if (props.usuario && props.usuario.acccompras !== "") {
                setModulofcompras({
                  compras1: props.usuario.acccompras.toString().substring(0, 1),
                  compras2: props.usuario.acccompras.toString().substring(1, 2)
                });
              } else {

              }

              txtComprassi.current.checked = true;
              txtComprasno.current.checked = false;
              setModu7(1);
            } else {
              txtComprassi.current.checked = false;
              txtComprasno.current.checked = true;
              setModu7(0);
            }
          }

          setOperacionPer(0);
        } else {
          setModulosincroniza({
            sincro1: "0",
            sincro2: "0",
          });
          setModulopedidos({
            pedidos1: "0",
            pedidos2: "0",
            pedidos3: "0",
            pedidos4: "0",
            pedidos5: "0"
          });
          setModulonataentrega({
            entrega1: "0",
            entrega2: "0"
          });
          setModuloanticipo({
            antic1: "0",
            antic2: "0",
            antic3: "0",
          });
          setModuloclientes({
            clients1: "0",
            clients2: "0",
            clients3: "0"
          });
          setModuloconfigura({
            config1: "0",
            config2: "0",
            config3: "0"
          });
          setModulofcompras({
            compras1: "0",
            compras2: "0"
          });
          txtClientessi.current.checked = false;
          txtClientesno.current.checked = true;
          txtConfiguracionsi.current.checked = false;
          txtConfiguracionno.current.checked = true;
          txtAnticipossi.current.checked = false;
          txtAnticiposno.current.checked = true;
          txtNotasentregasi.current.checked = false;
          txtNotasentregano.current.checked = true;
          txtPedidossi.current.checked = false;
          txtPedidosno.current.checked = true;
          txtSincronizarsi.current.checked = false;
          txtSincronizarno.current.checked = true;
          txtComprassi.current.checked = false;
          txtComprasno.current.checked = true;
          txtTipoventasi.current.checked = false;
          txtTipoventano.current.checked = true;
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registrar Usuario"
              : operacion === 2
                ? "Modificar Usurario"
                : operacion === 3
                  ? "Eliminar Usuario"
                  : "Consultar Usuario"}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <CatalogoCliente
          show={catalogoCliente}
          nomid={"vendedor"}
          onHideCancelar={() => setCatalogoCliente(false)}
          onHideAceptaCatalogo={onCatalogoCliente}
        />

        <CambiarClaveApp
          usuario={props.usuario && props.usuario.login.trim()}
          show={mostrar2}
          onHide={() => {
            setMostrar2(false);
          }}
        />

        <CatalogoPersona
          titulo={titulo}
          mensaje={msg}
          show={mostrar3}
          onHideCancelaCatPer={handleCloseCatalogoPer}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />

        <CatalogoOrganizacion
          show={mostrar}
          onHideCancelar={() => {
            setMostrar(false);
          }}
          onHideAceptaCatalogo={handleAceptaCatalogoOrg}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className="">
          <div>
            <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active "
                  style={{ backgroundColor: "#25d366" }}
                  id="ex-with-icons-tab-1"
                  data-mdb-toggle="tab"
                  href="#tab-1"
                  role="tab"
                  aria-controls="tab-1"
                  aria-selected="true"
                >
                  <i className="fas fa-user-edit fa-fw me-2"></i>Usuario
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link"
                  id="ex-with-icons-tab-2"
                  style={{ backgroundColor: "#55acee" }}
                  data-mdb-toggle="tab"
                  href="#tab-2"
                  role="tab"
                  aria-controls="tab-2"
                  aria-selected="false"
                >
                  <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos
                  Aplicaciones
                </a>
              </li>
            </ul>
            <div className="tab-content" id="ex-with-icons-content">
              <div
                className="tab-pane fade show active"
                id="tab-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">
                  <div className="input-group py-1 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Codigo:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtIdUsuario}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.usuario ? props.usuario.idusuario : ""
                      }
                      id="inputCodigo"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-file-signature"></i>Nom.
                      Usuario:
                    </label>
                    <input
                      type="text"
                      autocomplete="off"
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtLogin}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={props.usuario ? props.usuario.login : ""}
                      id="inputLogin"
                      onKeyUp={handleInputChange}
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-3 px-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {" "}
                      Estatus
                    </label>
                    <select
                      disabled={deshabilitado}
                      ref={cmbStatus}
                      className="form-select"
                      aria-label="Default select example"
                      defaultValue={props.usuario ? props.usuario.status : ""}
                    >
                      <option value="1">Activo</option>
                      <option value="2">Inactivo</option>
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>
                      Contraseña:
                    </label>
                    <input
                      type={mostrarClave ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-unlock-alt"></i>Confir.
                      Contr.:
                    </label>
                    <input
                      type={mostrarClave1 ? "text" : "password"}
                      disabled={operacion === 2 ? true : deshabilitado}
                      ref={txtConfirmPassword}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputConfirmPassword"
                      onKeyUp={handleInputChange}
                    />
                    <button
                      style={{ textAlign: "center", color: "white" }}
                      disabled={operacion === 2 ? true : deshabilitado}
                      onClick={mostrarPassword1}
                      className="btn btn-sm btn-info"
                    >
                      <i
                        disabled={deshabilitado}
                        className="fa fa-eye-slash"
                      ></i>{" "}
                    </button>
                  </div>
                  <div className="col-md-12 py-1"></div>
                  {props.menu === "sistema" && (
                    <fieldset className="row border-azul rounded mx-auto">
                      <legend className="float-none m-0 w-auto">
                        Organización
                      </legend>

                      <div className="input-group py-1 input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-id-card"></i>Código:
                        </label>
                        <input
                          type="text"
                          disabled={deshabilitado}
                          ref={txtIdAgente}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputIdAgente"
                          defaultValue={
                            props.usuario ? props.usuario.idorganizacion : ""
                          }
                          onKeyUp={validarAgente}
                          onBlur={validarAgente}
                        />
                        <button
                          disabled={deshabilitado}
                          onClick={() => {
                            setMostrar(true);
                          }}
                          className="btn btn-sm  btn-success"
                        >
                          <i
                            disabled={deshabilitado}
                            className="fa fa-search"
                          ></i>{" "}
                        </button>
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-8">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Nombres:
                        </label>
                        <input
                          type="text"
                          disabled={true}
                          ref={txtNombreAgente}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputNomUsuario"
                          defaultValue={
                            props.usuario ? props.usuario.nombreorg.trim() : ""
                          }
                        />
                      </div>
                    </fieldset>
                  )}

                  {props.menu !== "sistema" && (
                    <fieldset className="row border-azul rounded mx-auto">
                      <legend className="float-none m-0 w-auto">
                        Vendedor
                      </legend>

                      <input
                        ref={txtIdVendedor}
                        type="hidden"
                        name="idvendedor"
                      />

                      <div className="mb-1 col-pd-260">
                        <div className="input-group input-group-sm">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            Cedula/Rif
                          </label>
                          <select
                            ref={cmbRif}
                            name="cmbrif"
                            disabled={deshabilitado}
                            className="form-select form-select-sm text-center col-3"
                            aria-label=".form-select-sm example"
                          >
                            <option value="">--</option>
                            {cmbCedula &&
                              cmbCedula.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {" "}
                                  {item.value}{" "}
                                </option>
                              ))}
                          </select>
                          <input
                            ref={txtRif}
                            autoComplete="off"
                            disabled={deshabilitado}
                            maxLength={9}
                            type="text"
                            className="form-control"
                            name="cedula"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            onKeyUp={validarCliente}
                            onBlur={validarCliente}
                          />
                          <button
                            type="button"
                            disabled={deshabilitado}
                            onClick={() => {
                              setCatalogoCliente(true);
                            }}
                            className="btn btn-success"
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>
                      </div>
                      <div className="input-group pb-1 input-group-sm col-sm-3 px-4">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          Caja:
                        </label>
                        <select
                          disabled={deshabilitado}
                          ref={cmbCaja}
                          className="form-select"
                          aria-label="numero de caja"
                          defaultValue={
                            props.usuario ? props.usuario.numcaja : ""
                          }
                        >
                          <option value="">--</option>
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                        </select>
                      </div>
                      <div className="input-group input-group-sm mb-2 col-md-12">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          Nombre/Razón Social
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          ref={txtRazon}
                          disabled
                          name="nombres"
                          className="form-control text-uppercase"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>
                    </fieldset>
                  )}

                  <div className="col-md-12 py-1"></div>

                  <fieldset className="row border-azul rounded mx-auto">
                    <legend className="float-none m-0 w-auto">
                      Datos Personales del Usuario
                    </legend>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-3 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-id-card"></i>Cedula:
                        </label>
                        <input
                          type="text"
                          disabled={deshabilitado}
                          style={{ minWidth: 80, maxWidth: 80 }}
                          autoComplete="off"
                          maxLength={8}
                          ref={txtCedula}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCedula"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.cedula
                              : ""
                          }
                          onKeyUp={validarPersona}
                          onBlur={validarPersona}
                        />
                        {/*   <button disabled={deshabilitado} onClick={catalogoPer} className="btn btn-sm  btn-success" ><i disabled={deshabilitado} className="fa fa-search"></i> </button> */}
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-4 mx-auto px-2">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-map-marked-alt"></i>
                          Nacionalidad:
                        </label>
                        <select
                          disabled={!habilitadoNU}
                          ref={cmbNacionalidad}
                          style={{ minWidth: 70, maxWidth: 70 }}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nacionalidad
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example col-md-"
                        >
                          <option key="0" value="V">
                            V
                          </option>
                          <option key="1" value="E">
                            E
                          </option>
                        </select>
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-2 ml-auto px-1">
                        <label
                          className="input-group-text ml-2"
                          id="inputGroup-sizing-sm"
                        >
                          Sexo:
                        </label>
                        <select
                          disabled={!habilitadoNU}
                          ref={cmbSexo}
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.sexo
                              : ""
                          }
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option key="0" value="M">
                            M
                          </option>
                          <option key="1" value="F">
                            F
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Nombres:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtNombreUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputNomUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.nombres.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          apellidos:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtApellidoUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.apellidos.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-file-signature"></i>
                          Direccion:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtDireccionUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputApeUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.direccion.trim()
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="far fa-lg px-1 fa-calendar-alt"></i>
                          Fecha Nacimiento:
                        </label>
                        <input
                          type="date"
                          disabled={!habilitadoNU}
                          ref={txtFechaNac}
                          className="form-control px-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputFechaNac"
                          max={moment(fechaSistema).format("YYYY-MM-DD")}
                          defaultValue={
                            props.datospersonales
                              ? moment(
                                props.datospersonales.fnacimiento
                              ).format("YYYY-MM-DD")
                              : ""
                          }
                          onKeyUp={handleInputChange}
                        />
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-phone"></i>Telefono:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtTlfUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputTlfUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf1 !== null
                                ? props.datospersonales.tlf1.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          <i className="fas fa-lg px-1 fa-mobile-alt"></i>
                          Celular:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtCelUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputCelUsuario"
                          placeholder="0000-0000000"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.tlf2 !== null
                                ? props.datospersonales.tlf2.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="container col-md-12 row m-0">
                      <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          {" "}
                          <i className="fas fa-lg px-1 fa-at"></i>E-mail:
                        </label>
                        <input
                          type="text"
                          disabled={!habilitadoNU}
                          ref={txtEmailUsuario}
                          className="form-control"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputEmailUsuario"
                          defaultValue={
                            props.datospersonales
                              ? props.datospersonales.correoe !== null
                                ? props.datospersonales.correoe.trim()
                                : ""
                              : ""
                          }
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="tab-2"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-2"
              >
                <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">
                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Tipo de Venta</div>
                      <div className="form-check col px-3 form-check-inline px-2 mb-1">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipoventa"
                          disabled={deshabilitado}
                          id="inlineRadiotv"
                          value={true}
                          ref={txtTipoventasi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiotv">
                          De Contado
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2 mb-1">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipoventa"
                          disabled={deshabilitado}
                          id="inlineRadiotv1"
                          value={false}
                          ref={txtTipoventano}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiotv1">
                          Preventa
                        </label>
                      </div>
                      <div />
                    </div>
                  </div>
                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Sincronizar</div>
                      <div className="form-check col px-3 form-check-inline px-2 mb-1">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permisincroniza"
                          disabled={deshabilitado}
                          id="inlineRadio1"
                          value={true}
                          ref={txtSincronizarsi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2 mb-1">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permisincroniza"
                          disabled={deshabilitado}
                          id="inlineRadio2"
                          value={false}
                          ref={txtSincronizarno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>

                      {modu1 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={txtTodosSincronizar}
                                    defaultChecked={modulosincroniza.sincro1 === "1" && modulosincroniza.sincro2 === "1" ? true : false}
                                    onChange={checkTodo}
                                    name="todossincroniza"
                                    id="inlineCheckbox"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={txtRecibirProductos}
                                    defaultChecked={modulosincroniza.sincro1 === "1" ? true : false}
                                    onChange={checkBlank}
                                    name="sincroniza"
                                    id="inlineCheckbox1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox1"
                                  >
                                    Recibir. Productos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    disabled={deshabilitado}
                                    ref={txtEnviarPedidos}
                                    defaultChecked={modulosincroniza.sincro2 === "1" ? true : false}
                                    onChange={checkBlank}
                                    name="sincroniza"
                                    id="inlineCheckbox2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCheckbox2"
                                  >
                                    Enviar. Pedidos
                                  </label>
                                </div>
                              </th>

                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>
                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Pedidos</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permipedidos"
                          disabled={deshabilitado}
                          id="inlineRadiov1"
                          value={true}
                          ref={txtPedidossi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiov1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permipedidos"
                          disabled={deshabilitado}
                          id="inlineRadiov2"
                          value={false}
                          ref={txtPedidosno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiov2">
                          No Disponible
                        </label>
                      </div>

                      {modu2 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtTodosPedidos}
                                    disabled={deshabilitado}
                                    onChange={checkTodo}
                                    defaultChecked={modulopedidos.pedidos1 === "1" && modulopedidos.pedidos2 === "1" &&
                                      modulopedidos.pedidos3 === "1" && modulopedidos.pedidos4 === "1" && modulopedidos.pedidos5 === "1" ? true : false}
                                    name="todospedidos"
                                    type="checkbox"
                                    id="checkVentas"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtCrearPedidos}
                                    disabled={deshabilitado}
                                    defaultChecked={modulopedidos.pedidos1 === '1' ? true : false}
                                    onChange={checkBlank}
                                    type="checkbox"
                                    name="pedidos"
                                    id="checkVentas1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas1"
                                  >
                                    Crear Pedido
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtListaPedidos}
                                    disabled={deshabilitado}
                                    defaultChecked={modulopedidos.pedidos2 === '1' ? true : false}
                                    onChange={checkBlank}
                                    type="checkbox"
                                    name="pedidos"
                                    id="checkVentas2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas2"
                                  >
                                    Lista Pedidos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtListaPedidosClientes}
                                    disabled={deshabilitado}
                                    defaultChecked={modulopedidos.pedidos3 === '1' ? true : false}
                                    onChange={checkBlank}
                                    type="checkbox"
                                    name="pedidos"
                                    id="checkVentas3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas3"
                                  >
                                    Lista Pedidos Pendientes
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtEditarPedido}
                                    disabled={deshabilitado}
                                    defaultChecked={modulopedidos.pedidos4 === '1' ? true : false}
                                    onChange={checkBlank}
                                    type="checkbox"
                                    name="pedidos"
                                    id="checkVentas4"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas4"
                                  >
                                    Editar Pedido On-Line
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtPedidoGnotaentrega}
                                    disabled={deshabilitado}
                                    defaultChecked={modulopedidos.pedidos5 === '1' ? true : false}
                                    onChange={checkBlank}
                                    type="checkbox"
                                    name="pedidos"
                                    id="checkVentas5"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkVentas5"
                                  >
                                    Generar Nota de Entrega
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>
                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Notas de Entrega</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="perminotaentrega"
                          disabled={tipov !== 1 ? false : true}
                          id="inlineRadioc1"
                          value={true}
                          ref={txtNotasentregasi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioc1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="perminotaentrega"
                          disabled={tipov !== 1 ? false : true}
                          id="inlineRadioc2"
                          value={false}
                          ref={txtNotasentregano}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioc2">
                          No Disponible
                        </label>
                      </div>

                      {modu3 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtTodosnotasentrega}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={modulonataentrega.entrega1 === '1' && modulonataentrega.entrega2 === '1' ? true : false}
                                    name="todosnotaentregas"
                                    id="checkCompras"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkCompras"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtListaNotasEntregas}
                                    disabled={deshabilitado}
                                    defaultChecked={modulonataentrega.entrega1 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="notasentrega"
                                    id="checkCompras1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkCompras1"
                                  >
                                    Lista Notas de Entrega
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtObsequio}
                                    disabled={deshabilitado}
                                    defaultChecked={modulonataentrega.entrega2 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="notasentrega"
                                    id="checkCompras2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkCompras2"
                                  >
                                    Obsequi-Donación
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5">Modulo Vacios</div>


                      <table className="col-12 table table-sm table-bordered m-0 px-0">
                        <thead className="col-12 m-0 px-0">
                          <tr>
                            <th scope="col">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  ref={txtVaciosapp}
                                  disabled={tabIndex1 === 1 ? false : true}
                                  type="checkbox"
                                  onChange={checkBlank}
                                  name="vacios"
                                  id="checkVacios1"
                                />
                                <label
                                  className="form-check-label"
                                  for="checkVacios1"
                                >
                                  Acceso a Vacios
                                </label>
                              </div>
                            </th>
                            <th scope="col">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  ref={txtVaciosClient}
                                  disabled={tabIndex1 === 1 ? false : true}
                                  type="checkbox"
                                  onChange={checkBlank}
                                  name="vacios"
                                  id="checkVacios2"
                                />
                                <label
                                  className="form-check-label"
                                  for="checkVacios2"
                                >
                                  Lista Cientes Vacios
                                </label>
                              </div>
                            </th>
                            <th scope="col">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  ref={txtPrestamoVacios}
                                  disabled={tabIndex1 === 1 ? false : true}
                                  type="checkbox"
                                  onChange={checkBlank}
                                  name="vacios"
                                  id="checkVacios5"
                                />
                                <label
                                  className="form-check-label"
                                  for="checkVacios5"
                                >
                                  Prestamo de Vacios
                                </label>
                              </div>
                            </th>
                            <th scope="col">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  ref={txtCierreVacios}
                                  disabled={tabIndex1 === 1 ? false : true}
                                  type="checkbox"
                                  onChange={checkBlank}
                                  name="vacios"
                                  id="checkVacios3"
                                />
                                <label
                                  className="form-check-label"
                                  for="checkVacios3"
                                >
                                  Imprimir Cierre Vacios
                                </label>
                              </div>
                            </th>
                            <th scope="col">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  ref={txtCierreVaciosPlus}
                                  disabled={tabIndex1 === 1 ? false : true}
                                  type="checkbox"
                                  onChange={checkBlank}
                                  name="vacios"
                                  id="checkVacios4"
                                />
                                <label
                                  className="form-check-label"
                                  for="checkVacios4"
                                >
                                  Cierre Vacios Permiso Adicional
                                </label>
                              </div>
                            </th>
                          </tr>
                        </thead>
                      </table>
                      <div />
                    </div>
                  </div>

                  <div className="border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Modulo Anticipos</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permianticipos"
                          disabled={deshabilitado}
                          id="inlineRadiocb1"
                          value={true}
                          ref={txtAnticipossi}
                          onChange={handleChangeOtro}
                        />
                        <label
                          className="form-check-label"
                          for="inlineRadiocb1"
                        >
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permianticipos"
                          disabled={deshabilitado}
                          id="inlineRadiocb2"
                          value={false}
                          ref={txtAnticiposno}
                          onChange={handleChangeOtro}
                        />
                        <label
                          className="form-check-label"
                          for="inlineRadiocb2"
                        >
                          No Disponible
                        </label>
                      </div>

                      {modu4 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtTodosanticipos}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={moduloanticipo.antic1 === "1" && moduloanticipo.antic2 === "1" && moduloanticipo.antic3 === "1" ? true : false}
                                    name="todosanticipos"
                                    id="checkContabilidad"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtCrearAnticipos}
                                    disabled={deshabilitado}
                                    defaultChecked={moduloanticipo.antic1 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="anticipos"
                                    id="checkContabilidad1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad1"
                                  >
                                    Crear. Anticipo
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtListaAnticipos}
                                    disabled={deshabilitado}
                                    defaultChecked={moduloanticipo.antic2 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="anticipos"
                                    id="checkContabilidad2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad2"
                                  >
                                    Lista Anticipos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtImprimirAnticipos}
                                    disabled={deshabilitado}
                                    defaultChecked={moduloanticipo.antic3 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="anticipos"
                                    id="checkContabilidad3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="checkContabilidad3"
                                  >
                                    Imprimir Anticipos por Vendedor
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}
                      <div />
                    </div>
                  </div>
                  <div className="col-sm-12 py-1 mb-1 border-azul d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Modulo Clientes</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permiclientes"
                          disabled={deshabilitado}
                          id="inlineRadioCliente1"
                          value={true}
                          ref={txtClientessi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioCliente1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permiclientes"
                          disabled={deshabilitado}
                          id="inlineRadioCliente2"
                          value={false}
                          ref={txtClientesno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioCliente2">
                          No Disponible
                        </label>
                      </div>

                      {modu6 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtTodosClientes}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={moduloclientes.clients1 === '1' && moduloclientes.clients2 === '1' ? true : false}
                                    name="todosclientes"
                                    id="inlineClientes"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineClientes"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtListaClientes}
                                    disabled={deshabilitado}
                                    defaultChecked={moduloclientes.clients1 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="clientes"
                                    id="inlineClientes1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineClientes1"
                                  >
                                    Lista Clientes
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtDeudas}
                                    disabled={deshabilitado}
                                    defaultChecked={moduloclientes.clients2 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="clientes"
                                    id="inlineClientes2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineClientes2"
                                  >
                                    Lista Clientes Deudas
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtUbiCLientes}
                                    disabled={deshabilitado}
                                    defaultChecked={moduloclientes.clients3 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="clientes"
                                    id="inlineClientes3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineClientes3"
                                  >
                                    Registrar Ubicación Clientes
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  <div className="col-sm-12 py-1 mb-1 border-azul d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Modulo Facturas-Compra</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="factucompras"
                          disabled={deshabilitado}
                          id="inlineRadioCompra1"
                          value={true}
                          ref={txtComprassi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioCompra1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="factucompras"
                          disabled={deshabilitado}
                          id="inlineRadioCompra2"
                          value={false}
                          ref={txtComprasno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadioCompra2">
                          No Disponible
                        </label>
                      </div>

                      {modu7 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtTodosCompras}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={modulofcompras.compras1 === '1' && modulofcompras.compras2 === '1' ? true : false}
                                    name="todoscompras"
                                    id="inlineCompras"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCompras"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtFactucompras}
                                    disabled={deshabilitado}
                                    defaultChecked={modulofcompras.compras1 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="factucompra"
                                    id="inlineCompras1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCompras1"
                                  >
                                    Factura Compras
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtListaFactucompras}
                                    disabled={deshabilitado}
                                    defaultChecked={modulofcompras.compras2 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="factucompra"
                                    id="inlineCompras2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineCompras2"
                                  >
                                    Lista Facturas-Compra
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}

                      <div />
                    </div>
                  </div>

                  <div className="col-sm-12 py-1 mb-1 border-azul d-flex justify-content-between">
                    <div className="input-group col-sm-12 w-100">
                      <div className="col-sm-5"> Modulo Configuración</div>
                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permiconfiguracion"
                          disabled={deshabilitado}
                          id="inlineRadiof1"
                          value={true}
                          ref={txtConfiguracionsi}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiof1">
                          Disponible
                        </label>
                      </div>

                      <div className="form-check col px-3 form-check-inline px-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="permiconfiguracion"
                          disabled={deshabilitado}
                          id="inlineRadiof2"
                          value={false}
                          ref={txtConfiguracionno}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadiof2">
                          No Disponible
                        </label>
                      </div>

                      {modu5 === 1 ? (
                        <table className="col-12 table table-sm table-bordered m-0 px-0">
                          <thead className="col-12 m-0 px-0">
                            <tr>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtTodosConfiguracion}
                                    disabled={deshabilitado}
                                    type="checkbox"
                                    onChange={checkTodo}
                                    defaultChecked={moduloconfigura.config1 === "1" && moduloconfigura.config2 === "1" ? true : false}
                                    name="todosconfigura"
                                    id="inlineFinanzas"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas"
                                  >
                                    Todos
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtEliminarRegistros}
                                    disabled={deshabilitado}
                                    defaultChecked={moduloconfigura.config1 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="configura"
                                    id="inlineFinanzas1"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas1"
                                  >
                                    Eliminar Registros
                                  </label>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtListaMonedas}
                                    disabled={deshabilitado}
                                    defaultChecked={moduloconfigura.config2 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="configura"
                                    id="inlineFinanzas2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas2"
                                  >
                                    Lista Monedas
                                  </label>
                                </div>
                              </th>
                              {/* <th scope="col">
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    ref={txtFactucompras}
                                    disabled={deshabilitado}
                                    defaultChecked={moduloconfigura.config3 === '1' ? true : false}
                                    type="checkbox"
                                    onChange={checkBlank}
                                    name="configura"
                                    id="inlineFinanzas3"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="inlineFinanzas3"
                                  >
                                    Factura Compras
                                  </label>
                                </div>
                              </th> */}
                            </tr>
                          </thead>
                        </table>
                      ) : (
                        ""
                      )}
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-sm-12 d-flex justify-content-end row mx-auto py-1">
          <button
            type="button"
            onClick={() => {
              setMostrar2(true);
            }}
            style={{ visibility: operacion === 2 ? "visible" : "collapse" }}
            className="btn col-sm-3 mx-1 btn-warning btn-sm rounded-pill"
          >
            <i className="fas fa-key"> Cambiar Clave</i>{" "}
          </button>
          <button
            type="button"
            ref={btnAcepta}
            disabled={operacion === 4 ? true : false}
            onClick={onChangeValidar}
            className="col-sm-3 mx-1 btn-sm btn btn-success rounded-pill"
          >
            <i className="far fa-check-circle"></i>Aceptar
          </button>
          <button
            type="button"
            ref={btnCancela}
            onClick={cancelar}
            className="col-sm-3 mx-1 btn-sm btn btn-danger rounded-pill"
          >
            <i className="fas fa-window-close"></i>Cancelar
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalActualizarUsuarioApp;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalActualizarUsuarioApp.js